import { Pipe, PipeTransform } from '@angular/core';
import { StatusWeryfikacjiWOswiadczeniuODochodach } from '@interfaces/stypendia/oswiadczenia-o-dochodach/weryfikacja/status-weryfikacji-w-oswiadczeniu-o-dochodach.enum';

@Pipe({
  name: 'statusWeryfikacjiOswiadczeniaODochodach',
})
export class StatusWeryfikacjiOswiadczeniaODochodachPipe implements PipeTransform {
  transform(value: StatusWeryfikacjiWOswiadczeniuODochodach): string {
    const { Zatwierdzono, NieZatwierdzono, NieSprawdzono } = StatusWeryfikacjiWOswiadczeniuODochodach;
    switch (value) {
      case NieSprawdzono:
        return 'bg-warning text-secondary';
      case Zatwierdzono:
        return 'bg-success';
      case NieZatwierdzono:
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
